import { getFilterCacheList } from '@/utils/basicDataCache'
import { basicCacheKeys } from '@/utils/cacheConfig'
import * as NumberUtils from '@/utils/NumberUtils'
import moment from 'moment'
import { CurrencyUtil } from '@/class/cargo/model/utils/CurrencyUtil'

/**
 * 获取汇率-生效日期: 按分公司
 * @param sourceCode 原币种
 * @param targetCode 目标币种
 * @param businessDate 汇率日期
 * @param branchId 分公司Id
 */
export function getForeignExchangeRateSafely(sourceCode, targetCode, businessDate, branchId) {
  // 判断日期是否为字符串（有时候后端返回前端是json数据,日期已经是字符串了,此时需要转换一下）
  if (typeof businessDate === 'string') {
    businessDate = new Date(businessDate.replace(/-/g, '/'))
  }
  const inputMonth = businessDate.getMonth() + 1
  const month = String(businessDate.getFullYear()) + (inputMonth >= 10 ? String(inputMonth) : '0' + String(inputMonth))
  const currentMonthRateArray = getFilterCacheList(basicCacheKeys.basic_data_FxRateBranch, (item) => {
    return item.month === month &&
        item.branchId === branchId &&
        item.rateType === 1 && // 1=期间汇率 0=月汇率
        moment(businessDate).format('yyyy-MM-DD') >= moment(item.startDate).format('yyyy-MM-DD') &&
        moment(businessDate).format('yyyy-MM-DD') <= moment(item.endDate).format('yyyy-MM-DD')
  })
  let rate = NaN
  if (currentMonthRateArray && currentMonthRateArray.length > 0) {
    rate = getRateInMonth(sourceCode, targetCode, currentMonthRateArray)
  }
  if (isNaN(rate)) {
    return NaN
  }
  return NumberUtils.roundHalfUp(rate, 8)
}

export function getRateInMonth(targetCode, sourceCode, rates) {
  if (targetCode === sourceCode) {
    return 1.0
  }

  for (let i = 0; i < rates.length; i++) {
    const rate = rates[i]
    if (rate.currency === sourceCode && rate.baseCurrency === targetCode) {
      return parseFloat(rate.rate)
    }
  }

  let targetRate = null
  let sourceRate = null
  for (let i = 0; i < rates.length; i++) {
    const rate = rates[i]
    if (rate.currency === sourceCode) {
      targetRate = rate
      if (rate.baseCurrency === targetCode) {
        return parseFloat(targetRate.rate)
      }
      break
    }
  }
  for (let i = 0; i < rates.length; i++) {
    const rate = rates[i]
    if (rate.currency === targetCode) {
      sourceRate = rate
      if (rate.baseCurrency === sourceCode) {
        return CurrencyUtil.roundHalfUpRateByCurrency(sourceCode, 1.0 / parseFloat(sourceRate.rate))
      }
      break
    }
  }

  if (targetRate == null || sourceRate == null) {
    return NaN
  }

  if (sourceRate.baseCurrency !== targetRate.baseCurrency) {
    return NaN
  }
  const derived = parseFloat(targetRate.rate) / parseFloat(sourceRate.rate)
  return CurrencyUtil.roundHalfUpRateByCurrency(sourceCode, derived)
}
